import { Feature } from '@assetaccountant/api/models/feature';
import { environment } from 'environments/environment';

export const getFeatureDisplay = (feature: Feature) => {
  switch (feature) {
    case Feature.Adjustments:
    case Feature.Attachments:
    case Feature.Classifications:
    case Feature.Components:
      return Feature[feature];

    // Other
    case Feature.CustomFields:
      return 'Custom Fields';

    case Feature.DraftAssets:
      return 'Draft Assets';

    case Feature.RevaluationsImpairments:
      return 'Revaluations';

    case Feature.Impairments:
      return 'Impairments';

    case Feature.Quantities:
      return 'Partial Acquisitions / Quantities';

    case Feature.PartialDisposals:
      return 'Partial Disposals';

    case Feature.PremiumIntegration:
      return 'Premium Integration';

    case Feature.CustomDepreciationMethods:
      return 'Custom Depreciation Methods';

    case Feature.BulkActions:
      return 'Bulk Actions';

    case Feature.ConsolidatedReports:
      return 'Consolidated Reports';

    default:
      environment.warn(`Unexpected feature: ${Feature[feature]} (${feature})`);
      return Feature[feature];
  }
};
